import cookie from 'react-cookie';

export const GET_PACKAGE_LIST = 'GET_PACKAGE_LIST';
export const GET_PACKAGE = 'GET_PACKAGE';
export const GET_RETAIL = 'GET_RETAIL';
export const GET_POINTS = 'GET_POINTS';
export const GET_BILLS = 'GET_BILLS';
export const BUY_PACKAGE = 'BUY_PACKAGE';
export const BUY_RETAIL = 'BUY_RETAIL';
export const BUY_VIP = 'BUY_VIP';
export const GET_ONE_BILLS = 'GET_ONE_BILLS';
export const CANCEL_CONTRACT = 'CANCEL_CONTRACT';
export const LESSON_EXP = 'LESSON_EXP';
export const GET_CONFIG = 'GET_CONFIG';

/**
 * 套餐列表
 * @param {*} params 
 */
export function getPackageList() {

	var params = {};
	params.filter = {
		where: {
			type: params.type
		}
	}

	return {
		CALL_API: {
			type: GET_PACKAGE,
			method: 'get',
			target: `/packages`,
			params
		}
	}
}

/**
 * 取得套餐資訊
 * @param {*} params 
 */
export function getPackage(params){
	return {
		CALL_API: {
			type: GET_PACKAGE,
			method: 'get',
			target: `/packages/${params.id}`,
		}
	}
}

/**
 * 取得零售資訊
 */
export function getRetail(){
	return {
		CALL_API: {
			type: GET_RETAIL,
			method: 'get',
			target: '/packages/retail',
		}
	}
}

/**
 * 用戶點數列表及使用現狀
 * @param {*} params 
 */
export function getPoints(params){

	params.filter = {
		"include":[
			"contract"
		],
		"order":"create_time ASC" //排序,先進先出
	}

	return {
		CALL_API: {
            type: GET_POINTS,
            method: 'get',
            target: `/users/${params.user_id}/points`,
            header: {
                Authorization: cookie.load('token')
            },
			params
        }
	}
}

/**
 * 用戶訂單及點數使用紀錄
 * @param {*} params 
 */
export function getOneBills(params = {}){

	if( params.contract_id ) {
		params.filter = {
			"include":{
				"points": {
					"point_use_logs": {
						"sign_up": "class"
					}
				}
			},
			"where":{
				"id":params.contract_id
			}
		}
	}
	

	const user_id = cookie.load('user_id');

	return {
		CALL_API: {
            type: GET_ONE_BILLS,
            method: 'get',
            target: `/users/${user_id}/contracts`,
            header: {
                Authorization: cookie.load('token')
            },
			params
        }
	}
}


export function getBills(params = {}){

	const user_id = cookie.load('user_id');

	return {
		CALL_API: {
            type: GET_BILLS,
            method: 'get',
            target: `/users/${user_id}/contracts`,
            header: {
                Authorization: cookie.load('token')
            },
        }
	}
}


/**
 * 套餐下單
 * @param {*} params = {
	package_id,
	"type": "B2C", //B2C, B2B, LOVE,
	"print": true, //是否列印, 當type為B2C時需提供此資訊
	"name": "xx公司", //名稱, 當type為B2B時需提供此資訊
	"ubn": "12345678", //統編, 當type為B2B時需提供此資訊
	"code": "123456" //捐贈單位, 當type為LOVE時
 * }
 */
export const buyPackage = (params) => (dispatch, getState) => {

	const user_id = cookie.load('user_id');

    return dispatch({
        CALL_API: {
            type: BUY_PACKAGE,
            method: 'post',
            target: `/users/${user_id}/packages/${params.package_id}`,
            header: {
                Authorization: cookie.load('token')
            },
			params
        }
    })
}

/**
 * 零售下單
 * @param {*} params = {
 	user_id,
	"point": 12,
	"receipt_option": {
		"type": "B2C", //B2C, B2B, LOVE
		"print": true, //是否列印, 當type為B2C時需提供此資訊
		"name": "xx公司", //名稱, 當type為B2B時需提供此資訊
		"ubn": "12345678", //統編, 當type為B2B時需提供此資訊
		"code": "123456" //捐贈單位, 當type為LOVE時
	} 
 }
 */
export const buyRetail = (params) => (dispatch, getState) => {
    
	const user_id = cookie.load('user_id');
	
	return dispatch({
        CALL_API: {
            type: BUY_RETAIL,
            method: 'post',
            target: `/users/${user_id}/retailOrder`,
            header: {
                Authorization: cookie.load('token')
            },
			params
        }
    })
}

/**
 * VIP下單
 * @param {*} params = {
 	user_id,
	"type": "B2C", //B2C, B2B, LOVE,
	"print": true, //是否列印, 當type為B2C時需提供此資訊
	"name": "xx公司", //名稱, 當type為B2B時需提供此資訊
	"ubn": "12345678", //統編, 當type為B2B時需提供此資訊
	"code": "123456" //捐贈單位, 當type為LOVE時
 }
 */
export const buyVIP = (params) => (dispatch, getState) => {

	const user_id = cookie.load('user_id');

    return dispatch({
        CALL_API: {
            type: BUY_VIP,
            method: 'post',
            target: `/users/${user_id}/buyVIP`,
            header: {
                Authorization: cookie.load('token')
            },
			params
        }
    })
}

export function cancelContract(params) {

	const user_id = cookie.load('user_id');

	return {
		CALL_API: {
			type: CANCEL_CONTRACT,
			method: 'post',
			header: {
                Authorization: cookie.load('token')
            },
			target: `/users/${user_id}/cancelContract/${params.serial_no}`,
		}
	}
}

export function lessonExperienceContract(params) {
	return {
		CALL_API: {
			type: LESSON_EXP,
			method: 'post',
			header: {
                Authorization: cookie.load('token')
            },
			target: `/users/lessonExperienceContract/${params.sign_up_id}`,
			params: params.receipt_option
		}
	}
}

export function getConfig(params){
	return {
	  CALL_API: {
		type: GET_CONFIG,
		method: 'get',
		target: `/app_configs`,
		header: {
			Authorization: cookie.load('token')
		}
	  }
	}
  }


/** WEBPACK FOOTER **
 ** ./src/actions/packages.js
 **/